import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import logo from "../assets/images/ban-services.png";
import "../styles/services.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Layout from "../components/Layout";

const BACKEND_URL = "https://api.comprapapaya.com";

function Services() {
  /* =========================
    ESTADOS
  ========================= */
  const [servicesByCategory, setServicesByCategory] = useState({});
  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);

  const [step, setStep] = useState("select"); // select | booking | success

  const [clientName, setClientName] = useState("");

  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const [confirmedName, setConfirmedName] = useState("");
  const [confirmedDate, setConfirmedDate] = useState(null);
  const [confirmedTime, setConfirmedTime] = useState(null);

  // Estados para el formulario de reseña
  const [reviewName, setReviewName] = useState("");
  const [reviewEmail, setReviewEmail] = useState("");
  const [reviewRating, setReviewRating] = useState(5);
  const [reviewComment, setReviewComment] = useState("");

  /* =========================
    CARGAR SERVICIOS (PUBLIC)
  ========================= */
  useEffect(() => {
    cargarDatos();
  }, []);

  useEffect(() => {
    if (step === "success" && confirmedName) {
      const link = getWhatsappLink();
      window.open(link, "_blank");
    }
  }, [step]);

  const getWhatsappLink = () => {
    const phone = "51932587523";

    const message = `
Hola

Tengo una reserva confirmada

Nombre: ${confirmedName}
Fecha: ${confirmedDate?.toLocaleDateString("es-PE")}
Hora: ${confirmedTime?.toLocaleTimeString("es-PE", {
      hour: "2-digit",
      minute: "2-digit",
    })}

Emilia Nails Salon
    `;
    
    return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  };

  const cargarDatos = async () => {
    try {
      const [catRes, servRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/categories/public`),
        axios.get(`${BACKEND_URL}/services/public`)
      ]);
      const categorias = catRes.data;
      const serviciosAgrupados = servRes.data;

      setCategories(categorias);
      setServicesByCategory(serviciosAgrupados);

      const firtCategory = Object.keys(serviciosAgrupados)[0];
      if (firtCategory) {
        setActiveCategory(firtCategory);
      }

    } catch (error) {
      console.error("Error cargando servicios:", error);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
    HANDLERS
  ========================= */
  const handleAddService = (service) => {
    const exists = selectedServices.some((s) => s.id === service.id);

    if (exists) {
      setSelectedServices((prev) => prev.filter((s) => s.id !== service.id));
    } else {
      setSelectedServices((prev) => [...prev, service]);
    }
  };

  const handleRemoveService = (id) => {
    setSelectedServices(prev => prev.filter(s => s.id !== id));
  };

  const handleConfirmReservation = async () => {
    if (!clientName || !selectedDate || !selectedTime) {
      Swal.fire({
        icon: 'error',
        title: 'Campos incompletos',
        text: 'Por favor completa todos los campos',
        confirmButtonColor: '#e91e63'
      });
      return;
    }

    if (selectedServices.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Sin servicios',
        text: 'Selecciona al menos un servicio',
        confirmButtonColor: '#e91e63'
      });
      return;
    }

    const formattedDate = selectedDate.toISOString().split("T")[0];
    const formattedTime = selectedTime.toTimeString().slice(0, 5);

    try {
      await axios.post(`${BACKEND_URL}/reservations`, {
        services: selectedServices.map(s => s.id),
        client_name: clientName,
        date: formattedDate,
        time: formattedTime,
      });
      
      setConfirmedName(clientName);
      setConfirmedDate(selectedDate);
      setConfirmedTime(selectedTime);

      setStep("success");
      setSelectedServices([]);
      setClientName("");
      setSelectedDate(null);
      setSelectedTime(null);
    } catch (error) {
      if (error.response?.status === 409) {
        Swal.fire({
          icon: 'error',
          title: 'Horario ocupado',
          text: 'Este horario ya está reservado',
          confirmButtonColor: '#e91e63'
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al crear la reserva',
          confirmButtonColor: '#e91e63'
        });
      }
    }
  };

  // Handler para enviar reseña
  const handleSubmitReview = async (e) => {
    e.preventDefault();
  
    if (!reviewName || !reviewEmail || !reviewComment) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Completa todos los campos",
        confirmButtonColor: "#e91e63"
      });
      return;
    }
  
    try {
      await axios.post(`${BACKEND_URL}/reviews`, {
        name: reviewName,
        email: reviewEmail,
        rating: reviewRating,
        comment: reviewComment
      });
  
      Swal.fire({
        icon: "success",
        title: "¡Gracias!",
        text: "Tu reseña será revisada antes de publicarse",
        confirmButtonColor: "#e91e63"
      });
  
      setReviewName("");
      setReviewEmail("");
      setReviewRating(5);
      setReviewComment("");
  
    } catch (error) {
      console.error("Error enviando reseña:", error);
  
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo enviar la reseña",
        confirmButtonColor: "#e91e63"
      });
    }
  };


  const totalPrice = selectedServices.reduce(
    (sum, s) => sum + Number(s.price),
    0
  );

  /* =========================
    RENDER
  ========================= */
  
  return (
    <Layout>
    <div className="services">
      {/* HERO */}
      <div className="services-hero">
        <img src={logo} alt="Banner" />
        <div className="services-hero-overlay"></div>
      </div>

      {/* CONTENIDO PRINCIPAL */}
      <div className="services-content">
        {/* SIDEBAR */}
        <aside className="services-sidebar">
          {Object.keys(servicesByCategory).map((category) => (
            <button
              key={category}
              className={`services-category-item ${
                activeCategory === category ? "active" : ""
              }`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </aside>

        {/* GRID */}
        <main className="services-grid">
          {/* FORMULARIO */}
          {step === "booking" && (
            <div className="services-booking-panel services-booking-form">
              <h2 className="services-form">Formulario de Reserva</h2>

              <p>
                <strong className="services-form-subtitle">Servicios seleccionados:</strong>
              </p>
              <div className="booking-summary">
                {selectedServices.map((s) => (
                  <div key={s.id} className="booking-summary-item">
                    <span className="services-selected">{s.name}</span>
                    <span className="services-price">S/ {Number(s.price).toFixed(2)}</span>
                  </div>
                ))}

                <div className="booking-summary-total">
                  <strong className="booking-summary-price">Total</strong>
                  <strong className="booking-price">S/ {totalPrice.toFixed(2)}</strong>
                </div>
              </div>

              <p>
                <strong className="booking-total">Total: S/ {totalPrice.toFixed(2)}</strong>
              </p>

              <input
                type="text"
                placeholder="Nombre completo"
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
              />

              <div className="datepicker-field">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  minDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Selecciona una fecha"
                  className="services-datepicker"
                  popperPlacement="bottom-start"
                />
              </div>
              
              <div className="datepicker-field">
                <DatePicker
                  selected={selectedTime}
                  onChange={(time) => setSelectedTime(time)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  timeCaption="Hora"
                  dateFormat="HH:mm"
                  placeholderText="Selecciona una hora"
                  className="services-datepicker"
                  popperPlacement="bottom-start"
                />
              </div>

              <button
                className="services-reservation-button"
                onClick={handleConfirmReservation}
              >
                Confirmar Reserva
              </button>
            </div>
          )}

          {/* LISTADO DE SERVICIOS */}
          {step === "select" && (
            <div className="services-list">
              {!activeCategory && (
                <p className="services-empty">
                  Selecciona una categoría para ver los servicios
                </p>
              )}

              {activeCategory &&
                servicesByCategory[activeCategory]?.map((service) => (
                  <div key={service.id} className="service-card">
                    <h3>{service.name}</h3>
                    <p>{service.description}</p>
                    <span>S/ {service.price}</span>

                    <button
                      className="service-add-btn"
                      onClick={() => handleAddService(service)}
                    >
                      +
                    </button>
                  </div>
                ))}
            </div>
          )}

          {/* SUCCESS */}
          {step === "success" && (
            <div className="reservation-success">
              <div className="success-card">
                <div className="success-icon">💅</div>
          
                <h2>¡Reserva confirmada!</h2>
          
                <p className="success-text">
                  Gracias <strong>{clientName || "por confiar en nosotros"}</strong>
                </p>
          
                <div className="success-details">
                  <p>
                    📅 <strong>
                      {confirmedDate?.toLocaleDateString("es-PE")}
                    </strong>
                  </p>
                  <p>
                    ⏰ <strong>
                      {confirmedTime?.toLocaleTimeString("es-PE", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </strong>
                  </p>
                </div>
          
                <button
                  className="success-button"
                  onClick={() => setStep("select")}
                >
                  Hacer otra reserva
                </button>
              </div>
            </div>
          )}
        </main>
      </div>

      

      {/* CARRITO FLOTANTE */}
      {selectedServices.length > 0 && (
        <div className="services-cart">
          <h3>Servicios seleccionados</h3>

          {selectedServices.map(service => (
            <div key={service.id} className="cart-item">
              <span>{service.name}</span>
              <span>S/ {Number(service.price).toFixed(2)}</span>
              <button onClick={() => handleRemoveService(service.id)}>✕</button>
            </div>
          ))}

          <div className="cart-total">
            <strong>Total:</strong>
            <strong>S/ {totalPrice.toFixed(2)}</strong>
          </div>

          <button
            className="cart-continue"
            onClick={() => setStep("booking")}
          >
            Continuar con la reserva
          </button>
        </div>
      )}

      {/* SECCIÓN DE RESEÑAS */}
      <div className="review-section">
        <div className="review-container">
          <div className="review-image">
            <img src={logo} alt="Emilia Nails Salon" />
            <div className="review-image-overlay"></div>
          </div>

          <div className="review-form-wrapper">
            <div className="review-header">
              <h2>Déjanos tu reseña</h2>
              <p>Tu opinión es muy importante para nosotros</p>
            </div>

            <form onSubmit={handleSubmitReview} className="review-form">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Nombre completo"
                  value={reviewName}
                  onChange={(e) => setReviewName(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  placeholder="Correo electrónico"
                  value={reviewEmail}
                  onChange={(e) => setReviewEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label className="rating-label">Calificación:</label>
                <div className="star-rating">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      type="button"
                      className={`star ${reviewRating >= star ? 'active' : ''}`}
                      onClick={() => setReviewRating(star)}
                    >
                      ★
                    </button>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <textarea
                  placeholder="Cuéntanos tu experiencia..."
                  value={reviewComment}
                  onChange={(e) => setReviewComment(e.target.value)}
                  rows="5"
                  required
                />
              </div>

              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input type="checkbox" required />
                  <span>
                    He leído y acepto de manera expresa los Términos y condiciones 
                    y la Política de privacidad de datos personales.
                  </span>
                </label>
              </div>

              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input type="checkbox" />
                  <span>
                    Acepto de manera expresa recibir beneficios, ofertas, 
                    publicidad y novedades de Emilia Nails Salon.
                  </span>
                </label>
              </div>

              <button type="submit" className="review-submit-btn">
                Enviar Reseña
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    </Layout>
  );
}

export default Services;